export default "__VITE_ASSET__83fb8733__"